import { useState } from "react";
import { Order } from "../../../services/types/order.type";
import { TextButton } from "../../ui/buttons/TextButton/TextButton";
import { ItemMenu } from "../../ui/ItemMenu/ItemMenu";
import { BorderWrap } from "../../ui/wrappers/BorderWrap/BorderWrap";
import "./OrderItem.css";
import { useUpdateOrderStatusMutation } from "../../../store/orders/ordersApi";

interface OrderItemProps {
  item: Order;
  reload: () => void;
}

export const OrderItem = ({ item, reload }: OrderItemProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const [updateStatus] = useUpdateOrderStatusMutation();

  const menuClick = () => {
    setShowMenu((showMenu) => !showMenu);
  };

  const canceledOrder = async () => {
    if (window.confirm("Вы действительно хотите отменить этот заказ?")) {
      try {
        await updateStatus({
          uuid: item.uuid,
          newStatus: "CANCELLED",
        }).unwrap();
        reload();
      } catch (err) {
        console.error("Ошибка смены статуса", err);
      }
    }
  };

  const handleChangeStatus = async (newStatus: string) => {
    if (window.confirm("Вы действительно сменить статус заказа?")) {
      try {
        await updateStatus({ uuid: item.uuid, newStatus }).unwrap();
        reload();
      } catch (err) {
        console.error("Ошибка смены статуса", err);
      }
    }
  };

  return (
    <BorderWrap>
      <div className="order-item-number">Заказ №{item.orderNumber}</div>
      <div className="order-item-info">
        <div className="order-item-info-text">
          <span style={{ marginTop: ".5rem", opacity: 0.5 }}>
            Способ доставки
          </span>
          <br />
          {item.deliveryMethod}
        </div>
        <div className="order-item-info-text">
          <span style={{ marginTop: ".5rem", opacity: 0.5 }}>Адрес</span>
          <br />
          {item.deliveryAddress}
          {item.apartment ? ", кв. " + item.apartment : ""}
          {item.floor ? ", этаж " + item.floor : ""}
          {item.intercom ? ", домофон " + item.intercom : ""}
        </div>
        <div className="order-item-info-text">
          <span style={{ marginTop: ".5rem", opacity: 0.5 }}>Получатель</span>
          <br />
          {item.firstName} {item.lastName}
          <br />
          {item.phone}
        </div>
        <div className="order-item-info-text">
          <span style={{ marginTop: ".5rem", opacity: 0.5 }}>Комментарий</span>
          <br />
          {item.comment}
        </div>
        <ItemMenu showMenu={showMenu} menuClick={menuClick}>
          {item.status === "PAID" && (
            <TextButton
              text="В сборку"
              action={() => handleChangeStatus("SHIPPED")}
              margin="0 0 1rem 0"
            />
          )}
          {item.status === "SHIPPED" && (
            <TextButton
              text="В доставку"
              action={() => handleChangeStatus("DELIVERED")}
              margin="0 0 1rem 0"
            />
          )}
          {item.status === "DELIVERED" && (
            <TextButton
              text="Завершить"
              action={() => handleChangeStatus("DONE")}
              margin="0 0 1rem 0"
            />
          )}
          <TextButton text="Отменить заказ" action={canceledOrder} />
        </ItemMenu>
      </div>
      <div className="order-item-info-products">
        <div className="order-item-info-text">
          <span style={{ marginTop: ".5rem", opacity: 0.5 }}>Товары</span>
        </div>
        {item.items &&
          item.items.map((prod) => (
            <div key={prod.uuid} className="order-item-info-text">
              {prod.productName}, размер {prod.orderedSize}, {prod.quantity} шт.
            </div>
          ))}
      </div>
    </BorderWrap>
  );
};
